<template>
  <div class="book-viewer">
    <div
      class="
        book-viewer__head
        display-flex-center
        justify-content-between
        position-rel
      "
      :class="{
        'bg-color-light': !isFullSizeBook,
        'bg-transparent border-0': isFullSizeBook,
      }"
    >
      <router-link
        :to="{ name: 'ebook-detail', params: { id, slug } }"
        class="book-viewer__back secondary-color-txt font-size-16"
        :class="{ 'bg-color-light border-rd-50 full-size': isFullSizeBook }"
      >
        <i class="icon-close font-size-14 secondary-color-txt"></i>
        <span v-if="!isFullSizeBook" class="only-pc">Thoát</span>
      </router-link>
      <h1
        v-if="!isFullSizeBook"
        class="
          margin-0
          p-0
          book-viewer__title
          font-size-18
          secondary-color-txt
          font-sanpro-semibold
        "
      >
        {{ title ? title : ebooksDetail ? ebooksDetail.name : "" }}
      </h1>
      <span></span>
      <div
        title="Hướng dẫn sử dụng chức năng đọc sách"
        class="icon-help cursor-pointer"
        @click="openModalNotiHelp"
      >
        <i class="icon-question font-size-22"></i>
      </div>
    </div>
    <div class="read-ebook2">
      <div
        class="book-viewer__body justify-content-center"
        :class="{
          'sidebar-open':
            keySidebarActive === 'media' ||
            keySidebarActive === 'link' ||
            keySidebarActive === 'exercise',
          'cat-open': openBookCats,
          'display-flex': isMobile(),
          'display-flex-center': !isMobile(),
          'full-size': isFullSizeBook,
        }"
        :style="{ width: tabMenu > 0 ? '' : '95%' }"
      >
        <div
          class="chevron-next next-book only-pc"
          v-show="keySidebarActive !== 'exercise'"
        >
          <a
            @click="prev"
            href="javascript:void(0)"
            role="button"
            data-slide="prev"
            title="Quay trở lại trang trước"
          >
            <img src="@/assets/images/prev.png" alt="Trang trước" />
          </a>
        </div>
        <div class="flipbook-viewport" v-show="keySidebarActive !== 'exercise'">
          <div
            id="flipbook"
            :class="{ single: !displayTwoPage, double: displayTwoPage }"
          >
            <div
              class="page"
              :style="`background-image:url(${bookImgCdnUrl}${ebooksDetail.fileName}-1.jpg)`"
            ></div>
          </div>
        </div>
        <div
          class="chevron-next only-pc responsive-next"
          v-show="keySidebarActive !== 'exercise'"
        >
          <a
            title="Chuyển đến trang tiếp theo"
            @click="next"
            href="javascript:void(0)"
            role="button"
            data-slide="next"
          >
            <img src="@/assets/images/next.png" alt="Trang tiếp theo" />
          </a>
        </div>
      </div>
      <div class="suggest" :style="{ width: tabMenu > 0 ? '25%' : '0%' }">
        <div class="list-tab-menu">
          <div
            title="Công cụ học liệu"
            class="tab-search"
            :class="{ 'active-tab-menu': tabMenu == 2 ? true : false }"
            @click="onChangeTabMenu(2)"
          >
            <img src="@/assets/images/imagehoclieu.png" alt="Hành trang số" />
          </div>
          <div
            title="Công cụ liên kết"
            class="tab-search"
            :class="{ 'active-tab-menu': tabMenu == 3 ? true : false }"
            @click="onChangeTabMenu(3)"
          >
            <img src="@/assets/images/link.png" alt="Hành trang số" />
          </div>
          <div
            class="tab-search"
            title="Công cụ luyện tập"
            :class="{ 'active-tab-menu': tabMenu == 4 ? true : false }"
            @click="onChangeTabMenu(4)"
          >
            <img src="@/assets/images/pen.png" alt="Hành trang số" />
          </div>

          <!-- Fix bug: show icon trong mục cài đặt ( đổi thành 1-2 trang , phóng to thu nhỏ)
            ModifiedBy: anhdd (26/8/2022)
            -->
          <!-- <div class="book-viewer__switch only-pc">
            <div class="switch-viewpage full-width border-rd-20">
              <span class="bg-transition" />
              <label
                class="view-single"
                :class="{
                  'active-tab-menu': displayTwoPage == false ? true : false,
                }"
                @click="changeViewBookNew(false)"
                title="Hiển thị 1 trang"
              >
                <img src="@/assets/images/one-page.png" />
              </label>
              <label
                class="view-double"
                :class="{
                  'active-tab-menu': displayTwoPage == true ? true : false,
                }"
                @click="changeViewBookNew(true)"
                title="Hiển thị 2 trang"
              >
                <img src="@/assets/images/two-page.png" />
              </label>
            </div>
          </div>

          <div class="tab-search" @click="handleZoomBookIn">
            <img src="@/assets/images/zoom-in.png" title="Thu nhỏ" />
          </div>
          <div class="tab-search" @click="handleZoomBookOut">
            <img src="@/assets/images/zoom-out.png" title="Phóng to" />
          </div> -->
          <!-- End fix -->
        </div>
        <div class="content-tab-menu" v-if="tabMenu > 0">
          <div class="list-tab-menu-title">
            <div
              class="tab-menu-title"
              :class="{ 'active-tab-menu-title': tabMenu == 2 ? true : false }"
              @click="onChangeTabMenu(2)"
            >
              Học liệu
            </div>
            <div
              class="tab-menu-title"
              :class="{ 'active-tab-menu-title': tabMenu == 3 ? true : false }"
              @click="onChangeTabMenu(3)"
            >
              Liên kết
            </div>
            <div
              class="tab-menu-title"
              :class="{ 'active-tab-menu-title': tabMenu == 4 ? true : false }"
              @click="onChangeTabMenu(4)"
            >
              Luyện tập
            </div>
          </div>
          <div class="tab-link" v-if="tabMenu == 3">
            <div
              class="item-link"
              v-for="(itemBook, index2) in ebooksDetail.bookRelates"
              :key="index2"
            >
              <div class="item-link-left">
                <a href="javascript:;" @click="directDetailPage(itemBook)">
                  <img
                    class="inner-img"
                    v-lazy="
                      itemBook.imageUrl !== null
                        ? replaceLink(itemBook.imageUrl)
                        : ''
                    "
                    :alt="itemBook.name"
                  />
                </a>
              </div>
              <div class="item-link-right">
                <p :title="itemBook.name">{{ itemBook.name }}</p>
                <div>Tái bản: {{ itemBook.editionYear }}</div>
                <button
                  @click="directDetailPage(itemBook)"
                  class="btn-read-book-link"
                >
                  Đọc sách
                </button>
              </div>
            </div>
          </div>
          <div class="tab-course" v-if="tabMenu == 2">
            <div class="search-course">
              <input
                placeholder="Tìm kiếm theo tên..."
                v-model="paramSearchHocLieu.keyword"
                class="input-search-course"
                on
              />
              <!-- <svg @click="searchHocLieu(1,'none')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16" id="IconChangeColor"> <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" id="mainIconPathAttribute" stroke="#abc1e6"></path> </svg> -->
              <img
                @click="searchHocLieu(1, 'none')"
                src="@/assets/images/searchhoclieu.png"
              />
            </div>
            <div class="list-extension">
              <div>
                <button
                  class="item-extension"
                  :style="{
                    background:
                      paramSearchHocLieu.documentTypeId == 3
                        ? 'green'
                        : '#9EA7AE',
                  }"
                  @click="toggerDocumentTypeId(3)"
                >
                  Video
                </button>
              </div>
              <div>
                <button
                  class="item-extension"
                  :style="{
                    background:
                      paramSearchHocLieu.documentTypeId == 10
                        ? 'green'
                        : '#9EA7AE',
                  }"
                  @click="toggerDocumentTypeId(10)"
                >
                  Audio
                </button>
              </div>
              <div>
                <button
                  class="item-extension"
                  :style="{
                    background:
                      paramSearchHocLieu.documentTypeId == 9
                        ? 'green'
                        : '#9EA7AE',
                  }"
                  @click="toggerDocumentTypeId(9)"
                >
                  Hình ảnh
                </button>
              </div>
            </div>
            <div class="list-hoc-lieu" v-if="dataHocLieu">
              <vueCustomScrollbar
                class="scroll-area-hoc-lieu"
                v-if="dataHocLieu.listDocumentTypeModel.length > 0"
              >
                <div
                  class="item-hoc-lieu"
                  v-for="(item, index) of dataHocLieu.listDocumentTypeModel"
                >
                  <ItemLibrary
                    @onViewItem="onViewItem"
                    v-if="item"
                    :dataSource="item"
                    :isPlay="false"
                  />
                </div>
              </vueCustomScrollbar>
              <div class="noti-luyen-tap" v-else>
                {{ getThongBaoHocLieu() }}
              </div>
            </div>

            <div class="count-course" v-if="this.dataHocLieu">
              <div class="title-course">Tổng số học liệu</div>
              <div style="display: flex">
                <div style="width: 20%"></div>
                <div class="list-course">
                  <div
                    title="Số học liệu định dạng audio"
                    class="item-statitic"
                  >
                    <img src="@/assets/images/audio.png" />
                    <div class="count-item-statitic">
                      {{ this.dataHocLieu.statisticalDocumentType.countAudio }}
                    </div>
                  </div>
                  <div title="Số học liệu định dạng gif" class="item-statitic">
                    <img src="@/assets/images/gif.png" />
                    <div class="count-item-statitic">
                      {{ this.dataHocLieu.statisticalDocumentType.countGif }}
                    </div>
                  </div>
                  <div
                    title="Số học liệu định dạng video"
                    class="item-statitic"
                  >
                    <img src="@/assets/images/play.png" />
                    <div class="count-item-statitic">
                      {{ this.dataHocLieu.statisticalDocumentType.countVideo }}
                    </div>
                  </div>
                  <div
                    title="Số học liệu định dạng hình ảnh"
                    class="item-statitic"
                  >
                    <img src="@/assets/images/image.png" />
                    <div class="count-item-statitic">
                      {{ this.dataHocLieu.statisticalDocumentType.countImage }}
                    </div>
                  </div>
                </div>
                <div style="width: 20%"></div>
              </div>
            </div>
          </div>
          <div class="tab-link" v-if="tabMenu == 4">
            <div
              class="tab-luyen-tap noti-luyen-tap"
              v-if="dataLuyenTap.length == 0"
            >
              Cuốn sách này không có bài tập điện tử.
            </div>
            <div
              v-else
              class="item-link"
              v-for="(itemBook, index2) in dataLuyenTap"
              :key="index2"
            >
              <div class="item-link-left">
                <a href="javascript:;">
                  <img
                    class="inner-img"
                    v-lazy="
                      ebooksDetail.imageUrl !== null
                        ? replaceLink(ebooksDetail.imageUrl)
                        : ''
                    "
                    :alt="ebooksDetail.name"
                  />
                </a>
              </div>
              <div class="item-link-right">
                <p :title="ebooksDetail.name">{{ ebooksDetail.name }}</p>
                <div>Tái bản: {{ ebooksDetail.editionYear }}</div>
                <button
                  @click="redirectToLuyenTap(itemBook)"
                  class="btn-read-book-link"
                >
                  Luyện tập
                </button>
              </div>
            </div>
            <div class="statitic-question">
              <div class="count-question-title">
                Thống kê bài tập trong trang
              </div>
              <div class="count-question-content">
                Tổng số bài tập: {{ soluongBaiLuyenTap }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="book-viewer__footer"
      :class="{ 'bg-transparent border-0': isFullSizeBook }"
    >
      <!-- /** Fix page; Author: anhdd (6/7/2022)*/ -->
      <FooterBar
        :lstPage="lstPage"
        :lastPageCat1="lastPageCat1"
        :ebooksDetail="ebooksDetail"
        :page="page"
        :isPage1="isPage1"
        :displayTwoPage="displayTwoPage"
        :scale="scale"
        @zoom="handleZoomBook"
        @changeViewBook="changeViewBook"
        @directToPage="directToPage"
        @toggleCatsList="handleToggleBookCats"
        @prevPage="prev"
        @nextPage="next"
        @changeFullSizeBook="handleChangeFullSizeBook"
      />
    </div>
    <div
      class="book-viewer__cats"
      :class="{ active: openBookCats, 'full-size': isFullSizeBook }"
    >
      <div class="book-viewer__cats__wrap">
        <h2
          class="
            book-viewer__cats__title
            primary-color-txt
            font-size-24 font-sanpro-semibold
          "
        >
          Mục lục
        </h2>
      </div>
      <vue-custom-scrollbar
        class="scroll-area scroll-area__cats"
        :settings="settingsViewBookSidebar"
      >
        <div
          v-if="ebooksDetail && ebooksDetail.bookIndexs"
          class="book-viewer__cats__list"
        >
          <div class="book-viewer__cats__wrap">
            <b-card
              no-body
              v-for="(item, index) in ebooksDetail.bookIndexs"
              class="card-item"
              :key="index"
            >
              <div class="card-wrap display-block">
                <b-card-header
                  header-tag="header"
                  role="tab"
                  @click="openCollapse(`cat_${index}`, item)"
                  class="p-0 bg-transparent"
                >
                  <div
                    class="
                      cat-head
                      display-flex
                      justify-content-md-between
                      full-width
                    "
                    :class="{ active: collapseOpen === `cat_${index}` }"
                  >
                    <span
                      class="margin-0 font-size-16"
                      :class="`
                                      ${
                                        (item.pageNo <=
                                          ebooksDetail.limitPage &&
                                          !ebooksDetail.actived) ||
                                        (ebooksDetail.actived &&
                                          ebooksDetail.limitActivePage &&
                                          item.pageNo <=
                                            ebooksDetail.limitActivePage)
                                          ? ''
                                          : 'secondary-color-txt'
                                      } 
                                      ${
                                        collapseOpen === `cat_${index}`
                                          ? 'font-sanpro-semibold primary-color'
                                          : 'primary-color-txt'
                                      }
                                    `"
                    >
                      {{ item.title }}
                      <span v-if="item.title" class="cat-space-title">:</span>
                      {{ item.name }}
                    </span>
                  </div>
                </b-card-header>
                <b-collapse
                  :id="`cat_${index}`"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <ul
                      class="cat-child margin-0 p-0"
                      v-if="item.bookIndexChilds.length > 0"
                    >
                      <li
                        v-for="(child, pos) of item.bookIndexChilds"
                        :key="pos"
                      >
                        <a
                          href="javascript:;"
                          class="font-size-16"
                          :class="`
                                            ${
                                              (child.pageNo <=
                                                ebooksDetail.limitPage &&
                                                !ebooksDetail.actived) ||
                                              (ebooksDetail.actived &&
                                                ebooksDetail.limitActivePage &&
                                                child.pageNo <=
                                                  ebooksDetail.limitActivePage)
                                                ? ''
                                                : 'secondary-color-txt'
                                            } 
                                            ${
                                              catCurr.bookIndexId ===
                                                child.bookIndexId ||
                                              catCurr.parentId ===
                                                child.bookIndexId
                                                ? 'font-sanpro-semibold primary-color'
                                                : 'primary-color-txt'
                                            }
                                          `"
                          @click="openCollapse(`cat_child_${pos}`, child, 0)"
                        >
                          <!-- @click="openPageOfBook(child, index, pos)" -->
                          {{ child.title }}
                          <span v-if="child.title" class="cat-space-title"
                            >:</span
                          >
                          {{ child.name }}
                        </a>
                        <b-collapse
                          :id="`cat_child_${pos}`"
                          accordion="my-accordion-child"
                          role="tabpanelchild"
                        >
                          <b-card-body>
                            <ul
                              class="cat-child margin-0 p-0"
                              v-if="child.bookIndexChilds.length > 0"
                            >
                              <li
                                v-for="(child2, loc) of child.bookIndexChilds"
                                :id="`cat_row_${child2.bookIndexId}`"
                                :key="loc"
                              >
                                <a
                                  href="javascript:;"
                                  class="font-size-16"
                                  :class="`
                                                        ${
                                                          (child2.pageNo <=
                                                            ebooksDetail.limitPage &&
                                                            !ebooksDetail.actived) ||
                                                          (ebooksDetail.actived &&
                                                            ebooksDetail.limitActivePage &&
                                                            child2.pageNo <=
                                                              ebooksDetail.limitActivePage)
                                                            ? ''
                                                            : 'secondary-color-txt'
                                                        } 
                                                        ${
                                                          catCurr.bookIndexId ===
                                                          child2.bookIndexId
                                                            ? 'font-sanpro-semibold primary-color'
                                                            : 'primary-color-txt'
                                                        }
                                                      `"
                                  @click="
                                    openPageOfBook(child2, index, pos, loc)
                                  "
                                >
                                  {{ child2.title }}
                                  <span
                                    v-if="child2.title"
                                    class="cat-space-title"
                                    >:</span
                                  >
                                  {{ child2.name }}
                                </a>
                              </li>
                            </ul>
                          </b-card-body>
                        </b-collapse>
                      </li>
                    </ul>
                    <p
                      class="font-size-18 secondary-color-txt text-center"
                      v-else
                    >
                      Không có bài học nào
                    </p>
                  </b-card-body>
                </b-collapse>
              </div>
            </b-card>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>
    <modalShowHelp />
    <EbookQuestion
      v-if="
        (questionBookWorking && Object.keys(questionBookWorking).length) ||
        ($route.query && $route.query.question)
      "
      :cats="catsBookFlat"
      :questions="questions"
    />
    <EbookMedia
      v-if="
        mediaBookViewing &&
        Object.keys(mediaBookViewing).length &&
        $route.query &&
        $route.query.media &&
        $route.query.page
      "
    />
    <EbookLesson
      v-if="
        lessonBookViewing &&
        lessonBookViewing.length &&
        $route.query &&
        $route.query.lesson &&
        $route.query.page
      "
    />
    <!-- The Modal -->
    <div id="ModalViewer" class="modalviewer">
      <!-- Modal content -->
      <div class="modal-content">
        <span @click="closeModal" class="close">&times;</span>
        <DetailPageLinkLibBook ref="DetailPageLinkLibBook" />
      </div>
    </div>
  </div>
</template>

<script>
import { replaceImageResize } from "@/helpers/functions";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { STORE_KEY, LOCAL_SAVE_PAGE_OPEN } from "../_store/constants";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { APP_CONFIG } from "@/utils/constants";

import {
  getQuestionBookPage,
  getMediaInBookPage,
  setTimeReadBook,
  getLessonOnPage,
  getQuestionAreas,
  getLessonAreas,
  getMediaListInLibsNoPagination,
  GetCountQuestionIndex,
} from "./../_api/";
import { getlistExercise } from "@/modules/exercises/_api/exercise-list";
import {
  STORE_KEY as STORE_KEY_QUESTION,
  TYPE_GROUP,
} from "@/modules/question/preview-question/_store/constants";
import { getAuth } from "@/utils/jwt";
import {
  EMAIL_PUBLIC,
  EMAIL_UNLIMITED,
  EMAIL_NXB3,
} from "@/store/auth/constants";
import mixinsFiles from "@/components/content-files/mixinsFiles";
// import { ID_CLASS_1, ID_MATH_SUBJECT } from '@/store/common/constants'
import modalShowHelp from "@/components/modal/modalShowHelp";
import { callTimeDiff } from "@/helpers/functions";
import { setContentMediaEditorShow } from "@/modules/question/preview-question/_store/helperQuestionContent";
import mixinExercise from "@/modules/exercises/_store/mixinExercise";
import DetailPageLinkLibBook from "@/modules/libraries/_views/DetailPageLinkLibBook.vue";

export default {
  name: "EBookReadBook2",
  mixins: [mixinsFiles, mixinExercise],
  components: {
    modalShowHelp,
    vueCustomScrollbar,
    DetailPageLinkLibBook,
    ItemLibrary: () =>
      import("@/modules/libraries/_components/list/ItemLibraryBook.vue"),
    FooterBar: () => import("./ebook-viewer/FooterBar.vue"),
    EbookQuestion: () => import("./ebook-viewer/EbookQuestion.vue"),
    EbookMedia: () => import("./ebook-viewer/EbookMedia.vue"),
    EbookLesson: () => import("./ebook-viewer/EbookLesson.vue"),
  },
  data() {
    return {
      emailNxb3: EMAIL_NXB3,
      emailUnlimited: EMAIL_UNLIMITED,
      tabMenu: 0,
      nameRoute: this.$route.name,
      emailPublic: EMAIL_PUBLIC,
      id: this.$route.params.id,
      slug: this.$route.params.slug,
      title: null,
      // lessonId: 0,
      page: 0,
      isPage1: false /** Fix page; Author: anhdd (6/7/2022)*/,
      // pdfDoc: null,
      // zoom: 50,
      scale: 1,
      bookCdnUrl: APP_CONFIG.bookCdnUrl,
      bookImgCdnUrl: APP_CONFIG.bookImgCdnUrl,
      cdnUrl: APP_CONFIG.cdnUrl,
      appUrl: APP_CONFIG.bookCdnUrl,
      urlImg: APP_CONFIG.urlPlatformCmsImg,
      displayTwoPage: true,
      settingsViewBookSidebar: {
        maxScrollbarLength: 300,
      },
      collapseOpen: "",
      catCurr: {},
      isOpenSidebar: false,
      keySidebarActive: "", // search ||'link'
      openBookCats: false,
      actionWritePaging: false,
      openSidebarMobile: false,
      optionFlipBook: {
        width: 0,
        height: 0,
        autoCenter: true,
        duration: 800,
        acceleration: true,
        elevation: 50,
        gradients: true,
        cornerSize: 100,
      },
      // positionOpenPage: 0, //Check page prev or next for addPage or removePage
      // bookNumPages: [2, 0, 6],
      isEvtLastPage: false,
      inputPageDirect: 0,
      numberBookViewOpenSidebar: 1.3,
      disabledControls: false,
      isEvtPrevPage: false,
      isEvtNextPage: false,
      isFirstPage: true,
      isLastPage: false,
      questions: [],
      // typeGroup: TYPE_GROUP,
      // correctAnswersOfQuestions: [],
      // isQuestionCorrected: false,
      listMediaPage: [],
      isEvtActiveSuccess: false,
      pageCurrent: [0],
      authInfo: {},
      // indexQuestionCurr: 0,
      changeViewerForPageLimit: false,
      // scrollPosition: 0,
      // scrollEndQuestion: false,
      heightBookViewer: 0,
      thumbnailUrlShare: "",
      titleShare: "",
      isShowVideo: 1,
      // idClass1: ID_CLASS_1,
      // idMathSubject: ID_MATH_SUBJECT,
      // correct,
      // incorrect,
      // actionPlayQuestionTrue: false,
      // actionPlayQuestionFalse: false,
      startTimeReaded: 0,
      startTimeQuestion: 0,
      isFullSizeBook: false,
      percentEidthHeightImg: 1.43,
      // percentEidthHeightImg: 2.5,
      catsBookFlat: [],
      lessons: [],
      paramSearchHocLieu: {
        keyword: "",
        documentTypeId: 0,
        pageIndex: 1,
        pageSize: 12,
      },
      dataHocLieu: null,
      dataLuyenTap: [],
      soluongBaiLuyenTap: "0",
      configKeyclock: {},
      lastPageCat1: 0,
      lstPage: [],
    };
  },
  computed: {
    ...mapGetters({
      ebooksDetail: STORE_KEY + "/ebooksDetail",
      searchResult: STORE_KEY + "/searchResult",
      visiblePreviewModal: "common/visiblePreviewModal",
      docPreview: "common/docPreview",
      toggle_draw: `common/toggle_draw`,
      loading: `common/loading`,
    }),
    ...mapState(STORE_KEY, [
      "paramSearchRelateMedia",
      "questionBookWorking",
      "mediaBookViewing",
      "lessonBookViewing",
    ]),
    ...mapState(STORE_KEY_QUESTION, ["valVituralKeyboard"]),
    ...mapState("common", [
      "visiblePreviewSliderModal",
      "idBookActiveSuccess",
      "isShowModalActiveBookPage",
      "mediaShareInfo",
    ]),
    ...mapState("auth", ["loginPopupData"]),
    modalviewer() {
      return document.getElementById("ModalViewer");
    },
    screenWidth() {
      return window.innerWidth;
    },
    screenInnerHeight() {
      return window.innerHeight;
    },
    queryRoute() {
      return this.$route.query;
    },
  },
  watch: {
    ebooksDetail(newVal) {
      // Sách mần non
      // ModifiedBy: anhdd (8/12/2022)
      if (newVal) {
        if (newVal.classNo == 0) {
          this.percentEidthHeightImg = 2.5;
        } else this.percentEidthHeightImg = 1.43;
      }
      //-------------

      if (newVal && newVal.bookIndexs) {
        this.lastPageCat1 = newVal.limitPage - 1;
        this.lstPage = [];
        // for (let i = 0; i < newVal.bookIndexs.length; i++) {
        //   const itemBookIndex = newVal.bookIndexs[i];
        //   for (let j = 0; j < itemBookIndex.bookIndexChilds.length; j++) {
        //     let itemBookChild = itemBookIndex.bookIndexChilds[j]
        //     for(let k=0;k<itemBookChild.bookIndexChilds.length;k++){
        //       let itemChild = itemBookChild.bookIndexChilds[k]
        //       this.lstPage.push({pageNo:itemChild.pageNo,name:itemChild.name})
        //     }
        //   }
        // }
        if (this.lstPage.length == 0) {
          for (let i = 0; i < newVal.bookIndexs.length; i++) {
            const itemBookIndex = newVal.bookIndexs[i];
            for (let j = 0; j < itemBookIndex.bookIndexChilds.length; j++) {
              let itemBookChild = itemBookIndex.bookIndexChilds[j];
              this.lstPage.push({
                pageNo: itemBookChild.pageNo,
                name: itemBookChild.name,
              });
            }
          }
        }
        if (this.lstPage.length == 0) {
          for (let i = 0; i < newVal.bookIndexs.length; i++) {
            const itemBookIndex = newVal.bookIndexs[i];
            this.lstPage.push({
              pageNo: itemBookIndex.pageNo,
              name: itemBookIndex.name,
            });
          }
        }
      }
      newVal && !this.isEvtActiveSuccess && this.settingFlipBook();
      if (this.isEvtActiveSuccess) {
        this.isEvtActiveSuccess = false;
      }
      if (
        this.queryRoute &&
        this.queryRoute.shared === window.location.origin &&
        this.queryRoute.book_page &&
        this.checkBookActive(parseInt(this.queryRoute.book_page))
      ) {
        $("#flipbook").turn("page", parseInt(this.queryRoute.book_page));
      }
      this.titleShare = newVal.name ? newVal.name : "";
      // Mixin exercise flat array
      this.catsBookFlat = this.flatenCats(newVal.bookIndexs);
    },
    loginPopupData(newVal) {
      if (newVal && Object.keys(newVal).length) {
        this.authInfo = newVal;
      }
    },
    valVituralKeyboard(newVal) {
      if (newVal.ref) {
        document.getElementById(newVal.ref).value = newVal.val;
        document.getElementById(newVal.ref).focus();
      }
    },
    idBookActiveSuccess(newVal) {
      if (parseInt(newVal) === this.ebooksDetail.bookId) {
        this.handleActiveBookSuccess();
      }
    },
    mediaShareInfo(newVal) {
      if (newVal && newVal.titleLink) {
        this.thumbnailUrlShare = newVal.posterLink
          ? `${this.urlImg}/${newVal.posterLink}`
          : `${this.appUrl}${newVal.linkUrl}`;
        this.titleShare = newVal.titleLink;
      }
    },

    questionBookWorking(newVal) {
      if (
        newVal &&
        this.page !== newVal.pageNo &&
        this.page === 1 &&
        newVal.pageNo &&
        this.queryRoute &&
        this.queryRoute.question
      ) {
        // Direct page for case f5 page
        this.directToPage(newVal.pageNo);
      }
    },

    mediaBookViewing(newVal) {
      if (
        newVal &&
        this.page !== newVal.pageNo &&
        this.page === 1 &&
        newVal.pageNo &&
        this.queryRoute &&
        this.queryRoute.question
      ) {
        // Direct page for case f5 page
        this.directToPage(newVal.pageNo);
      }
    },
  },
  created() {
    this.actionCheckRouterHelp({ nameRoute: this.nameRoute });
    this.setVituralKeyVal({});
    window.addEventListener("keyup", this.onKeyup);
    this.authInfo = getAuth();
  },
  async mounted() {
    this.getEBooksDetail(this.id);
    this.requiredLibs();
    const request = await fetch(APP_CONFIG.dataUrl + "IsLoginkeyCloak");
    const response = await request.json();
    this.configKeyclock = response;
    //this.$refs.shortcutKey.focus()
    // this.setWidthBookDefault()
    // this.getPdf(this.defaultPage)
    // window.addEventListener('mouseup', this.onMouseup)
    this.startTimeReaded = new Date();

    this.setHeightBookViewer();
    // GetCountQuestionIndex(this.ebooksDetail.bookId).then((response)=>{
    //   console.log(response)
    // })
  },
  beforeDestroy() {
    // window.removeEventListener('mouseup', this.onMouseup)
    this.handleSendTimeReadBook();
    // this.resetValKeyboard();
    window.removeEventListener("keyup", this.onKeyup);
    localStorage.removeItem(LOCAL_SAVE_PAGE_OPEN);
  },

  methods: {
    ...mapActions(STORE_KEY, [
      "getEBooksDetail",
      "setBookDetail",
      "acSetEbookQuestionWork",
      "acSetMediaBookViewing",
      "acSetLessonBookViewing",
    ]),
    ...mapActions("auth", ["setToggleLoginForm", "setToggleLoginSSOForm"]),
    ...mapActions("common", [
      "setLoading",
      "setToggleModalDocSlider",
      "setDocPreviewSlider",
      "setToggleModalActivePage",
      "acSetDataBookActiveWant",
      "acToggleModalActiveBook",
      "acToggleModaShowHelp",
      "actionCheckRouterHelp",
      "setActionCheckQuestion",
      "actionGetVideoHelp",
      "actionSetPageNoBook",
      "actionSetBookIdForError",
    ]),
    ...mapMutations(STORE_KEY, ["SET_PARAM_SEARCH_RELATE_MEDIA"]),
    ...mapActions(STORE_KEY_QUESTION, [
      "setVituralKeyVal",
      "setQuestionData4CheckAnswer",
    ]),
    isContainsEmailUnlimited(email){
        let listEmailUnlimited = this.emailUnlimited.split(',')
        return listEmailUnlimited.indexOf(email) > -1
    },
    redirectToLuyenTap(itemBook) {
      let classId = this.ebooksDetail.classId;
      let subjectId = this.ebooksDetail.subjectId;

      let routeData = this.$router.resolve({
        name: "exerciseDetail",
        params: {
          classId,
          subjectId,
          bookType: itemBook.bookTypeId,
          practiceType: 3,
        },
      });
      window.open(routeData.href, "_blank");
    },
    getThongBaoHocLieu() {
      let thongBao = "Trang sách này không có học liệu";
      if (this.paramSearchHocLieu.documentTypeId != 0) {
        if (this.paramSearchHocLieu.documentTypeId == 3) {
          thongBao += " dạng Video.";
        } else if (this.paramSearchHocLieu.documentTypeId == 10) {
          thongBao += " dạng Audio.";
        } else if (this.paramSearchHocLieu.documentTypeId == 9) {
          thongBao += " dạng Hình ảnh.";
        }
        return thongBao;
      } else {
        return "Trang sách này không có học liệu.";
      }
    },
    onChangeTabMenu(tab) {
      if (this.tabMenu == tab) {
        this.tabMenu = 0;
        return;
      }
      this.tabMenu = tab;

      if (tab == 4) {
        let self = this;
        getlistExercise(self.ebooksDetail.classId).then((response) => {
          this.dataLuyenTap = [];
          let data = response;
          for (let i = 0; i < data.length; i++) {
            if (data[i].practiceTypeId === self.ebooksDetail.bookTypeId) {
              for (
                let index = 0;
                index < data[i].practiceSujectNewModel.length;
                index++
              ) {
                let subject = data[i].practiceSujectNewModel[index];
                if (subject.subjectId === self.ebooksDetail.subjectId) {
                  for (let j = 0; j < subject.practiceTypeNew.length; j++) {
                    if (
                      subject.practiceTypeNew[j].bookTypeId ==
                      self.ebooksDetail.bookGroupId
                    ) {
                      self.dataLuyenTap.push({
                        bookTypeId: subject.practiceTypeNew[j].bookTypeId,
                        bookTypeName: subject.practiceTypeNew[j].bookTypeName,
                      });
                    }
                  }
                  break;
                }
              }
              break;
            }
          }
          // console.log(this.dataLuyenTap);
        });
        // lấy số bài tập trong trang
        this.getCountQuestion("none");
      } else if (tab == 2) {
        this.searchHocLieu(1);
      }
    },
    getCountQuestion(type,pageForce =0) {
      this.soluongBaiLuyenTap = "0";
      let pageStart =
        this.screenWidth < 992 || !this.displayTwoPage
          ? this.page
          : this.pageCurrent[0];
      let pageStop =
        this.screenWidth < 992 || !this.displayTwoPage
          ? this.page
          : this.pageCurrent.length > 1
          ? this.pageCurrent[1]
          : this.pageCurrent[0];
      if (type == "next") {
        if(!this.displayTwoPage){
          pageStart = pageStart + 1;
          pageStop = pageStop + 1;
        }
        else{
          pageStart = pageStart + 2;
          pageStop = pageStop + 2;
        }
        
      } else if (type == "prev") {
        if(!this.displayTwoPage){
          pageStart = pageStart - 1;
          pageStop = pageStop - 1;
        }else{
          pageStart = pageStart - 2;
          pageStop = pageStop - 2;
        }
        
      }
      if(pageForce!=0){
        if(!this.displayTwoPage){
          pageStart = pageForce;
          pageStop = pageForce;
        }else{
          pageStart = pageForce;
          pageStop = pageForce +1;
        }
      }
      GetCountQuestionIndex(this.ebooksDetail.bookId, pageStart, pageStop).then(
        (response) => {
          this.soluongBaiLuyenTap = response.countQuestion;
        }
      );
    },
    closeModal() {
      this.modalviewer.style.display = "none";
    },
    onViewItem(data) {
      this.$refs.DetailPageLinkLibBook.getInfoLib(data.pagelinksId);
      this.modalviewer.style.display = "block";
    },
    // infiniteScroll(){
    //   if(this.paramSearchHocLieu.pageIndex>=this.dataHocLieu.paging.totalPage){
    //     return;
    //   }
    //   let pageIndex= this.paramSearchHocLieu.pageIndex + 1 > this.dataHocLieu.paging.totalPage? this.dataHocLieu.paging.totalPage: this.paramSearchHocLieu.pageIndex + 1
    //   this.searchHocLieu(pageIndex)
    // },
    toggerDocumentTypeId(type) {
      if (this.paramSearchHocLieu.documentTypeId == type) {
        this.paramSearchHocLieu.documentTypeId = 0;
      } else {
        this.paramSearchHocLieu.documentTypeId = type;
      }

      this.searchHocLieu(1, "none");
    },
    searchHocLieu(pageIndex = 1, type = "none",pageForce = 0) {
      let pageStart =
        this.screenWidth < 992 || !this.displayTwoPage
          ? this.page
          : this.pageCurrent[0];
      let pageStop =
        this.screenWidth < 992 || !this.displayTwoPage
          ? this.page
          : this.pageCurrent.length > 1
          ? this.pageCurrent[1]
          : this.pageCurrent[0];
      if (type == "next") {
        pageStart = pageStart + 2;
        pageStop = pageStop + 2;
      } else if (type == "prev") {
        pageStart = pageStart - 2;
        pageStop = pageStop - 2;
      }
      this.paramSearchHocLieu.pageIndex = 1;
      this.paramSearchHocLieu.bookId = this.ebooksDetail.bookId;
      if(pageForce!=0){
        if(!this.displayTwoPage){
          pageStart = pageForce;
          pageStop = pageForce;
        }else{
          pageStart = pageForce;
          pageStop = pageForce +1;
        }
      }
      this.paramSearchHocLieu.pageStart = pageStart;
      this.paramSearchHocLieu.pageStop = pageStop;
      getMediaListInLibsNoPagination(this.paramSearchHocLieu).then(
        (response) => {
          this.dataHocLieu = response.data;
        }
      );
    },
    directDetailPage(itemBook) {
      !this.preview &&
        this.$router.push({
          name: "ebook-detail",
          params: { id: itemBook.bookId, slug: itemBook.slug },
        });
    },

    replaceLink(link) {
      return replaceImageResize(link, { width: 285, height: 404 });
    },
    openModalNotiHelp() {
      this.actionGetVideoHelp({ isShowVideo: this.isShowVideo });
      this.acToggleModaShowHelp(true);
      // this.actionCheckRouterHelp(this.nameRoute)
      // ebook-read-book
      // this.$bvModal.hide(ID_MODAL_ACTIVE_BOOK)
    },

    requiredLibs() {
      // let self = this;
      require("./../../../assets/libs/jquery.min.1.7.js");
      require("./../../../assets/libs/hash.js");
      require("./../../../assets/libs/turn.min.js");
      // require('./../../../assets/libs/modernizr.2.5.3.min.js');
      // require('./../../../assets/libs/turn.html4.min.js');
      // require('./../../../assets/libs/zoom.min.js');
      // require('./../../../assets/libs/magazine.js');
      // require('./../../../assets/libs/magazine.css');
      // self.settingFlipBook()
      this.setStyleHeightForMobile();
    },

    setHeightBookViewer() {
      let heightScreen = window.innerHeight;
      let heightBarScreen =
        document.getElementsByClassName("book-viewer__head")[0].clientHeight +
        document.getElementsByClassName("book-viewer__footer")[0].clientHeight;
      this.heightBookViewer = this.isFullSizeBook
        ? heightScreen
        : heightScreen - heightBarScreen;
    },

    setStyleHeightForMobile() {
      let widthScreen = window.innerWidth;
      // let ratio = window.devicePixelRatio || 1;

      // let screen = {
      //     width : window.screen.width * ratio,
      //     height : window.screen.height * ratio
      // };
      // let heightForMobile = (this.iOS() && screen.width == 1125 && screen.height === 2436) ? `calc(100vh - 235px)` : `calc(100vh - 185px)`;
      let heightForMobile = window.innerHeight;

      if (widthScreen < 576 || this.isFullSizeBook) {
        document.getElementsByClassName("book-viewer__body")[0].style.height =
          heightForMobile;
        document.getElementsByClassName("book-viewer__cats")[0].style.height =
          heightForMobile;
        // document.getElementsByClassName('book-viewer__sidebar')[0].style.height = heightForMobile;
      }
    },

    getSizeBodyBook() {
      let self = this;
      const heighHeader =
        document.getElementsByClassName("book-viewer__head")[0].clientHeight;
      const heighFooter = document.getElementsByClassName(
        "book-viewer__footer"
      )[0].clientHeight;
      let flipBookBody =
        document.getElementsByClassName("book-viewer__body")[0];
      // let heightFlipBook = flipBookBody.clientHeight;
      let heightFlipBook = window.innerHeight - (heighHeader + heighFooter);
      // const percentEidthHeightImg = 1.43;
      let widthFlipBook = heightFlipBook * self.percentEidthHeightImg;
      self.optionFlipBook.width = self.isMobile()
        ? window.innerWidth
        : widthFlipBook;
      // self.optionFlipBook.width = window.innerWidth < 992 ? window.innerWidth : widthFlipBook;
      // self.optionFlipBook.height = heightFlipBook;
      // Height toolbar for brower mobile
      const heightToolbarMobile = 50;
      // const heightFlip = window.innerHeight - (heighHeader + heighFooter);
      // self.optionFlipBook.height = self.isMobile() ? heightFlip + heightToolbarMobile : heightFlip;
      self.optionFlipBook.height = heightFlipBook;
    },

    settingFlipBook() {
      let self = this;
      self.getSizeBodyBook();
      // self.bookNumPages = [ 2, self.ebooksDetail.totalPage, 6];
      let pageOpenSave =
        localStorage.getItem(LOCAL_SAVE_PAGE_OPEN) || self.$route.query.page;

      // Disabled flip book for mobile
      // document.getElementById('flipbook').addEventListener('touchstart', function(e){
      //   e.preventDefault();
      // });

      (function () {
        "use strict";
        $("#flipbook").turn({
          ...self.optionFlipBook,
          acceleration: !self.isChrome(),
          pages: self.ebooksDetail.totalPage,
          gradients: true,
          autoCenter: true,
          display: self.isMobile() ? "single" : "double",
          when: {
            start(evt, pageObject, corner) {
              // console.log('Start:', corner);
              // if (corner != null && self.screenWidth < 768) {
              if (corner != null) {
                $(this).turn("data").hover = true;
                self.setLoading(false);
                /**
                 * Fix bug 13: ...
                 * Modified: anhdd (24/8/2022)
                 */
                //return evt.preventDefault(); // Tắt chức năng lật sách ở góc trang
              }
            },
            turning: function (event, page, view) {
              // console.log(
              //   "Turning",
              //   $(".ss-question__icon").clicked,
              //   $(this).turn("data").hover
              // );
              // return event.preventDefault()
              // console.log('Corner turning: ', event)
              // if ($(this).turn('data').hover && self.screenWidth < 768) {
              //   $(this).turn('data').hover = false;
              //   self.setLoading(false)
              //   return event.preventDefault();
              // }
              // Return hover corner for desktop & mobile
              if ($(this).turn("data").hover) {
                $(this).turn("data").hover = false;
                self.setLoading(false);
                /**
                 * Fix bug 13: ...
                 * Modified: anhdd (24/8/2022)
                 */
                //return event.preventDefault(); // Tắt chức năng lật sách ở góc trang
              }
              // Check limit page
              if (!self.checkBookActive(page)) {
                if (view.length > 1) {
                  if (
                    self.screenWidth > 991 &&
                    page < self.ebooksDetail.totalPage
                  ) {
                    // self.changeViewBook({target: {checked: false}})
                    self.changeViewBook(false);
                    self.changeViewerForPageLimit = true;
                  }
                  self.fetchDataInPage();
                  // Promise.allSettled([self.getMediaInfoOfPage(), self.getQuestionsForPage(), self.fetchAreaLessonOnPage()])
                  // self.getMediaInfoOfPage()
                  // self.getQuestionsForPage()
                  // self.getLessonForPage()
                } else {
                  self.setLoading(false);
                }
                self.disabledControls = false;
                self.isEvtLastPage = false;

                return event.preventDefault();
              } else {
                self.page = page;
                // Set style margin left for first page double
                let menuOrSidebarOpen = self.openBookCats || self.isOpenSidebar;
                self.setStyleForFirstPage(page, menuOrSidebarOpen);
              }

              if (
                self.keySidebarActive === "exercise" &&
                self.isOpenSidebar &&
                !self.checkBookActiveForMediaExercise()
              ) {
                self.keySidebarActive = "";
                self.isOpenSidebar = false;
              }
            },
            turned: function (event, page, view) {
              // self.correctAnswersOfQuestions = [];
              // Open disabled for all controls
              self.disabledControls = false;
              self.page = page;
              // Set style margin left for first page double
              let menuOrSidebarOpen = self.openBookCats || self.isOpenSidebar;
              self.setStyleForFirstPage(page, menuOrSidebarOpen);

              // Check limit page
              if (
                ((page >= self.ebooksDetail.limitPage &&
                  !self.ebooksDetail.actived &&
                  self.ebooksDetail.limitPage % 2 === 0) ||
                  (self.ebooksDetail.limitActivePage &&
                    page >= self.ebooksDetail.limitActivePage &&
                    self.ebooksDetail.actived &&
                    self.ebooksDetail.limitActivePage % 2 === 0)) &&
                self.displayTwoPage &&
                self.screenWidth > 991
              ) {
                // self.changeViewBook({target: {checked: false}});
                self.changeViewBook(false);
                self.changeViewerForPageLimit = true;
              } else if (
                self.changeViewerForPageLimit &&
                self.screenWidth > 991
              ) {
                self.changeViewerForPageLimit = false;
                self.changeViewBook(true);
              }

              let totalPage = self.ebooksDetail.totalPage;

              if (page === 1 || page === 0) {
                self.isFirstPage = true;
                self.isLastPage = false;
              } else if (page === totalPage || page === totalPage - 1) {
                self.isFirstPage = false;
                self.isLastPage = true;
              } else {
                self.isFirstPage = self.isLastPage = false;
                self.listMediaPage = [];
                self.getMediaInfoOfPage();
              }
              self.setPageCurr();
              // self.fetchDataInPage()
              Promise.allSettled([
                self.getQuestionsForPage(),
                self.getLessonForPage(),
              ]);
              // self.getQuestionsForPage()
              // self.getLessonForPage
            },
            missing: function (event, pages) {
              let lengthPages = pages.length;
              pages.map((page, index) => {
                $("#flipbook").turn(
                  "addPage",
                  self.newPageHtml(page + 1),
                  page
                );
                // if(page !== 2 && page <= self.ebooksDetail.totalPage + 1) {
                //     console.log('Missing: ', page, pages, self.isEvtPrevPage, self.isEvtNextPage);
                //     $('#flipbook').turn('addPage', self.newPageHtml(page), !self.isEvtPrevPage ? page - 1 : page);
                //     // $('#flipbook').turn('addPage', self.newPageHtml(!self.isEvtPrevPage ? page : page + 1), !self.isEvtPrevPage ? page - 1 : page);
                //     // $('#flipbook').turn('addPage', self.newPageHtml(!self.isEvtPrevPage ? page : page + 1), !self.isEvtPrevPage ? page - 1 : page);
                // }

                if (index === lengthPages - 1) {
                  self.isEvtPrevPage = false;
                }
              });

              // let totalPage = (self.ebooksDetail.actived || self.ebooksDetail.limitPage==null||self.ebooksDetail.limitPage==0)?self.ebooksDetail.totalPage:self.ebooksDetail.limitPage;
              let totalPage = self.ebooksDetail.totalPage;
              // If is evt direct to last-page
              if (self.isEvtLastPage) {
                $("#flipbook").turn("page", totalPage);
                self.isEvtLastPage = false;
              }
            },
          },
        });
      })();
      // Direct page saved
      if (pageOpenSave && pageOpenSave !== undefined) {
        setTimeout(() => {
          $("#flipbook").turn("page", pageOpenSave);
          localStorage.removeItem(LOCAL_SAVE_PAGE_OPEN);
        }, 500);
      }

      if (
        this.$route.query &&
        this.$route.query.page &&
        this.$route.query.page !== 0
      ) {
        setTimeout(() => {
          $("#flipbook").turn("page", this.$route.query.page);
        }, 500);
      }
    },

    setStyleForFirstPage(page, openModal = false) {
      if (
        (page == 1 || page === 0) &&
        this.displayTwoPage &&
        !this.isMobile()
      ) {
        let numberSpaceViewBookSplit = !openModal
          ? this.optionFlipBook.width / 2 / 2
          : this.optionFlipBook.width / 2 / 2 / this.numberBookViewOpenSidebar;
        $(".flipbook-viewport").css(
          "margin-left",
          `-${numberSpaceViewBookSplit}px`
        );
      } else {
        $(".flipbook-viewport").css("margin-left", 0);
        $("#flipbook").turn("center");
      }
    },

    isMobile() {
      // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      return window.innerWidth < 991;
    },

    isChrome() {
      return navigator.userAgent.indexOf("Chrome") != -1;
    },

    isSafari() {
      return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    },

    iOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },

    newPageHtml(page) {
      let self = this;
      let totalPage = self.ebooksDetail.totalPage;
      if (page === totalPage + 1 && (totalPage + 1) % 2 === 0) {
        return $("<div />", { class: "page", style: `background: #f5f5f5;` });
      } else {
        return $("<div />", {
          class: "page",
          style: `background-image:url(${self.bookImgCdnUrl}${self.ebooksDetail.fileName}-${page}.jpg)`,
        });
      }
    },

    async prev() {
      // this.resetValKeyboard();
      let self = this;
      this.getCountQuestion("prev");
      /**
       * Begin: Fix page
       * Author: anhdd (6/7/2022)
       */
      if (
        self.page === 1 &&
        $(".page.p1.odd").css("background-image").includes("-2.jpg")
      ) {
        $(".page.p1.odd").css(
          "background-image",
          `url(${self.bookImgCdnUrl}${self.ebooksDetail.fileName}-1.jpg)`
        );
        self.isPage1 = false;
        return;
      } else if (self.page === 2 || self.page === 3) {
        self.isPage1 = true;
      } else {
        self.isPage1 = false;
      }
      /**
       * End: Fix page
       * Author: anhdd (6/7/2022)
       */
      // Turnoff turnjs hover corner book support for click icon question or media
      $("#flipbook").turn("data").hover = false;
      self.resetAreaQuestionAndMedia();
      self.isShowModalActiveBookPage && self.setToggleModalActivePage(false);
      // self.indexQuestionCurr = 0;
      if (self.page !== 1 && self.page !== 0) {
        self.setLoading(true);
        await $("#flipbook").turn("previous");
        // self.$bvModal.hide('modal_active_book');
        self.acToggleModalActiveBook(false);
        self.setToggleLoginForm(false);
      }

      if (self.changeViewerForPageLimit) {
        if (self.widthScreen > 991) {
          self.changeViewerForPageLimit = false;
          // self.changeViewBook({target: {checked: true}});
          self.changeViewBook(true);
        }
        self.fetchDataInPage();
        // Promise.allSettled([ self.getMediaInfoOfPage(), self.getQuestionsForPage(), self.getLessonForPage() ])
        // self.getMediaInfoOfPage();
        // self.getQuestionsForPage();
      }
      console.log(this.page)
      
      this.searchHocLieu(1, "prev");
    },
    async next() {
      this.getCountQuestion("next");
      // this.resetValKeyboard();
      let self = this;
      /**
       * Begin: Fix page
       * Author: anhdd (6/7/2022)
       */
      if (
        self.page === 1 &&
        $(".page.p1.odd").css("background-image").includes("-1.jpg")
      ) {
        $(".page.p1.odd").css(
          "background-image",
          `url(${self.bookImgCdnUrl}${self.ebooksDetail.fileName}-2.jpg)`
        );
        self.isPage1 = true;
        return;
      } else self.isPage1 = false;
      /**
       * End: Fix page
       * Author: anhdd (6/7/2022)
       */
      // Turnoff turnjs hover corner book support for click icon question or media
      $("#flipbook").turn("data").hover = false;
      self.resetAreaQuestionAndMedia();
      let pageDirect = self.displayTwoPage ? self.page + 2 : self.page + 1;
      let totalPage = self.ebooksDetail.totalPage;

      this.actionSetPageNoBook(pageDirect);
      if (self.page < totalPage - 1) {
        // self.indexQuestionCurr = 0;
        self.setLoading(true);
        await $("#flipbook").turn("next");
        // watch limit practicle
        // self.checkSidebarActive();
      }
      console.log(this.page)
      
      this.searchHocLieu(1, "next");
    },
    first() {
      // this.resetValKeyboard();
      // Turnoff turnjs hover corner book support for click icon question or media
      $("#flipbook").turn("data").hover = false;
      this.resetAreaQuestionAndMedia();
      this.disabledControls = true;
      this.isShowModalActiveBookPage && this.setToggleModalActivePage(false);
      setTimeout(() => {
        $("#flipbook").turn("previous").turn("page", 1);
      }, 500);
    },

    async last() {
      // this.resetValKeyboard();
      let self = this;
      // Turnoff turnjs hover corner book support for click icon question or media
      $("#flipbook").turn("data").hover = false;
      self.resetAreaQuestionAndMedia();
      self.disabledControls = true;
      self.isEvtLastPage = true;
      let totalPage = self.ebooksDetail.totalPage;
      // self.checkSidebarActive();
      if (self.page === 1 || self.page === 0) {
        await $("#flipbook").turn("next").turn("page", totalPage);
      } else {
        await $("#flipbook").turn("page", totalPage);
      }
    },

    handleZoomBook(val) {
      this.scale = val;
      // this.resetValKeyboard()
      $("#flipbook").turn("zoom", val);
      this.setOverflowViewer();
    },

    /** Fix bug: show icon trong mục cài đặt ( đổi thành 1-2 trang , phóng to thu nhỏ)
        ModifiedBy: anhdd (26/8/2022) */
    handleZoomBookOut() {
      this.scale += 0.2;
      this.handleZoomBook(this.scale);
    },

    handleZoomBookIn() {
      if (this.scale > 0) {
        this.scale -= 0.2;
        this.handleZoomBook(this.scale);
      }
    },

    setOverflowViewer() {
      let bodyFlip = document.getElementsByClassName("book-viewer__body")[0];
      if (bodyFlip) {
        bodyFlip.style.overflow = this.scale > 1 ? "scroll" : "hidden";
      }
    },

    changeViewBook(val) {
      // this.resetValKeyboard();
      this.resetAreaQuestionAndMedia();
      this.displayTwoPage = val;
      this.scale = 1;
      if (val) {
        $("#flipbook").turn("display", "double");
      } else {
        $("#flipbook").turn("display", "single");
        $(".flipbook-viewport").css("margin-left", 0);
      }
      // Set scale default
      $("#flipbook").turn("zoom", 1);
      this.fetchDataInPage();

      // Set style margin left for first page double
      if (!this.isOpenSidebar && !this.openBookCats) {
        this.resetPageWhenOfBoxsTransition();
      } else if (this.openBookCats) {
        this.setSpaceSizeForOpenCatBox();
      }
      // else if (this.isOpenSidebar) {
      //   this.setSpaceSizeForOpenSidebarBox()
      // }
      this.loading && this.setLoading(false);
      this.searchHocLieu(1, "none");
      this.getCountQuestion('none')
    },

    onKeyup(e) {
      e.keyCode === 37 && this.prev();
      e.keyCode === 39 && this.next();
    },
    onCheckLogin() {
      if (this.configKeyclock.isLoginKeyClock == 0) {
        this.setToggleLoginForm(true);
      } else {
        this.setToggleLoginSSOForm(true);
        //const pageUrl = window.location.href;
        //window.location.href= this.configKeyclock.urlServerKeyCloak+"/realms/"+this.configKeyclock.realm+"/protocol/openid-connect/auth?response_type=code&client_id="+this.configKeyclock.audience+"&redirect_uri="+window.location.origin+this.configKeyclock.redirect +'?urlReturn='+ pageUrl
      }
    },
    checkBookActive(page) {
      if (
        (page > this.ebooksDetail.limitPage && !this.ebooksDetail.actived) ||
        (this.ebooksDetail.limitActivePage &&
          page > this.ebooksDetail.limitActivePage)
      ) {
        // && this.keySidebarActive === 'exercise'
        if (
          this.authInfo &&
          this.authInfo.email === this.emailPublic &&
          page > this.ebooksDetail.limitPage &&
          !this.ebooksDetail.actived
        ) {
          this.onCheckLogin();
        } else {
          if (
            page > this.ebooksDetail.limitPage &&
            !this.ebooksDetail.actived
          ) {
            this.acSetDataBookActiveWant({ ...this.ebooksDetail });
            setTimeout(() => {
              this.acToggleModalActiveBook(true);
            }, 100);
          }

          // page > this.ebooksDetail.limitPage && !this.ebooksDetail.actived && this.$bvModal.show('modal_active_book');
          this.ebooksDetail.limitActivePage &&
            page > this.ebooksDetail.limitActivePage &&
            this.ebooksDetail.actived &&
            this.setToggleModalActivePage(true);
        }
        return false;
      }
      return true;
    },

    checkBookActiveForMediaExercise() {
      if (
        (this.page > this.ebooksDetail.limitPracticeX &&
          !this.ebooksDetail.actived) ||
        (this.ebooksDetail.limitPracticeY &&
          this.page > this.ebooksDetail.limitPracticeY)
      ) {
        if (this.authInfo && this.authInfo.email === this.emailPublic) {
          this.onCheckLogin();
        } else {
          if (
            this.page > this.ebooksDetail.limitPracticeX &&
            !this.ebooksDetail.actived
          ) {
            this.acSetDataBookActiveWant({ ...this.ebooksDetail });
            setTimeout(() => {
              this.acToggleModalActiveBook(true);
            }, 100);
          }
          // this.page > this.ebooksDetail.limitPracticeX && !this.ebooksDetail.actived && this.$bvModal.show('modal_active_book');
          this.ebooksDetail.limitPracticeY &&
            this.page > this.ebooksDetail.limitPracticeY &&
            this.setToggleModalActivePage(true);
        }
        return false;
      }
      return true;
    },

    openCollapse(id, cat, id2) {
      if (cat.bookIndexChilds.length > 0) {
        this.$root.$emit("bv::toggle::collapse", id);
      }
      this.catCurr = cat;
      if (!id2 && id2 !== 0) {
        this.collapseOpen = this.collapseOpen === id ? "" : id;
      }
      // chuyển trang ở mục lục cấp 2
      // if(id2 === 0){
      this.openPageOfBook(cat);
      // }
      // click là chuyển trang
      //   this.openPageOfBook(cat)
    },

    openPageOfBook(data, indexParent, index) {
      if (data && data.pageNo && this.checkBookActive(data.pageNo)) {
        this.catCurr = data;
        $("#flipbook").turn("page", data.pageNo);
        if (this.isMobile()) {
          this.openBookCats = false;
        }
      }
    },

    // handleToggleBookCats () {
    handleToggleBookCats(val) {
      // this.resetValKeyboard()
      this.openBookCats = val;
      this.isOpenSidebar = false;
      this.keySidebarActive = "";

      if (!this.isMobile() && this.openBookCats) {
        this.setSpaceSizeForOpenCatBox();
      }
      if (!this.openBookCats) {
        this.resetPageWhenOfBoxsTransition();
      }
    },

    setSpaceSizeForOpenCatBox() {
      let self = this;
      let bodyBookBox = document.getElementsByClassName("book-viewer__body")[0];
      let catBox = document.getElementsByClassName("book-viewer__cats")[0];
      let widthCatBox = catBox.clientWidth;
      let widthViewScreen =
        self.optionFlipBook.width / self.numberBookViewOpenSidebar;
      let widthByTypeDisplay = self.displayTwoPage
        ? widthViewScreen
        : widthViewScreen / 2;

      $("#flipbook").turn(
        "size",
        widthByTypeDisplay,
        self.optionFlipBook.height / self.numberBookViewOpenSidebar
      );
      // bodyBookBox.style.paddingLeft = `${widthCatBox}px`;
      // bodyBookBox.style.paddingRight = 0;
      bodyBookBox.style.marginLeft = `${widthCatBox}px`;
      bodyBookBox.style.marginRight = 0;
      self.setStyleForFirstPage(self.page, true);
    },

    resetPageWhenOfBoxsTransition() {
      let self = this;
      self.getSizeBodyBook();
      let bodyBookBox = document.getElementsByClassName("book-viewer__body")[0];
      // bodyBookBox.style.paddingLeft = 0;
      // bodyBookBox.style.paddingRight = 0;
      bodyBookBox.style.marginLeft = 0;
      bodyBookBox.style.marginRight = 0;
      let widthView = self.optionFlipBook.width;
      const heightForBook = self.isFullSizeBook
        ? window.innerHeight
        : self.optionFlipBook.height;
      let widthByTypeDisplay = self.displayTwoPage ? widthView : widthView / 2;
      let widthFlipBook = self.isFullSizeBook
        ? heightForBook * self.percentEidthHeightImg
        : widthByTypeDisplay;

      // Sách mần non
      // ModifiedBy: anhdd (8/12/2022)
      if (!self.displayTwoPage && self.isMobile()) widthFlipBook = widthView;
      //------------
      // $('#flipbook').turn('size', widthByTypeDisplay, heightForBook)
      $("#flipbook").turn("size", widthFlipBook, heightForBook);
      self.setStyleForFirstPage(self.page, false);
    },

    openInputChangePaging() {
      this.isEvtPrevPage = this.isEvtNextPage = false;
      this.actionWritePaging = true;
      this.inputPageDirect = "";
      this.$nextTick(function () {
        this.$refs.direct_page.focus();
      });
      // console.log(this.$refs.direct_page.$el);
      // document.getElementById('direct_page').focus();
      // this.$refs.direct_page.$el.focus();
      // this.$refs.direct_page.autofocus = true;
    },

    directToPage(evt) {
      let self = this;
      
      // self.isEvtPrevPage = false
      // self.isEvtNextPage = false
      // let value = evt.target.value
      let value = evt;
      if (value) {
        // Turnoff turnjs hover corner book support for click icon question or media
        $("#flipbook").turn("data").hover = false;
        let totalPage = self.ebooksDetail.totalPage;
        if (parseInt(value) > parseInt(totalPage)) {
          self.last();
          // self.inputPageDirect = self.ebooksDetail.totalPage - 1;
        } else if (parseInt(value) === 0 || parseInt(value) === 1) {
          self.first();
        } else {
          self.isFirstPage = self.isLastPage = false;
          self.checkBookActive(value) && $("#flipbook").turn("page", value);
        }
      }
      this.actionWritePaging = false;
      this.actionSetPageNoBook(this.inputPageDirect);
      this.getCountQuestion("none",evt);
      this.searchHocLieu(1, "none",evt);
    },

    openZoomMobile() {
      this.openSidebarMobile = !this.openSidebarMobile;
      if (!this.openSidebarMobile) {
        this.isOpenSidebar = false;
      }
    },

    setPageActive() {
      let pageActive = [this.page];
      if (this.displayTwoPage) {
        pageActive =
          this.page % 2 === 0
            ? [this.page, this.page + 1]
            : [this.page - 1, this.page];
      }
      return pageActive;
    },

    setPageCurr() {
      if (this.displayTwoPage && !this.actionWritePaging && this.page > 1) {
        // let totalPage = (self.ebooksDetail.actived || self.ebooksDetail.limitPage==null||self.ebooksDetail.limitPage==0)?self.ebooksDetail.totalPage:self.ebooksDetail.limitPage;
        let totalPage = this.ebooksDetail.totalPage;
        if (this.page % 2 === 0 && this.page === totalPage - 1) {
          this.pageCurrent = [this.page];
        } else if (this.page % 2 === 0) {
          this.pageCurrent = [this.page, this.page + 1];
        } else {
          this.pageCurrent = [this.page - 1, this.page];
        }
      } else if (
        !this.displayTwoPage &&
        this.page > 1 &&
        !this.actionWritePaging
      ) {
        this.pageCurrent = [this.page];
      }
    },

    async fetchAreaLessonOnPage() {
      const self = this;
      let reqGetArea;
      if (!self.displayTwoPage || self.screenWidth < 992) {
        reqGetArea = await getLessonAreas(self.ebooksDetail.bookId, self.page);
        reqGetArea &&
          reqGetArea.length &&
          self.insertLessonIconIntoPage(reqGetArea);
      } else {
        // have 2 page [0, 1]
        reqGetArea = await self.pageCurrent.map((page) => {
          return getLessonAreas(self.ebooksDetail.bookId, page).then((res) => {
            if (!res || (res && res.length === 0)) {
              return [];
            }
            return res;
          });
        });

        Promise.all(reqGetArea).then((res) => {
          if (res) {
            const dataArea = [...res[0], ...res[1]];
            dataArea &&
              dataArea.length > 0 &&
              self.insertLessonIconIntoPage(dataArea);
          }
        });
      }
    },

    getLessonForPage() {
      const pageStart =
        this.screenWidth < 992 || !this.displayTwoPage
          ? this.page
          : this.pageCurrent[0];
      const pageStop =
        this.screenWidth < 992 || !this.displayTwoPage
          ? this.page
          : this.pageCurrent.length > 1
          ? this.pageCurrent[1]
          : this.pageCurrent[0];
      /*
       * arg: bookId, pageStart, pageStop
       **/
      pageStop > 0 &&
        getLessonOnPage(this.ebooksDetail.bookId, pageStart, pageStop).then(
          (res) => {
            // page > 0 && getLessonOnPage(this.ebooksDetail.bookId, page, page ).then(res => {
            if (res && res.length > 0) {
              res.map((less) => {
                const data = this.setLessonDataToStore(less);
                this.lessons.push(data);
              });
              this.fetchAreaLessonOnPage();
            }
          }
        );
    },

    getQuestionsForPage() {
      let self = this;
      // if(self.questions) {
      //     let questionBox = document.getElementById('questions_box');
      //     questionBox && questionBox.scrollIntoView();
      // }
      self.setLoading(true);
      let pageActive = self.setPageActive();
      if (pageActive[0] !== 0) {
        /**
         * Params call questions:
         * bookId - bookIndexId - pageIndex - numberOfPage
         **/
        let numberOfPage = self.displayTwoPage ? 2 : 1;
        let paramFethQuestion = {
          bookId: self.ebooksDetail.bookId,
          bookIndexId: 0,
          pageIndex: pageActive[0],
          numberOfPage,
        };
        // console.log('params search: ', paramFethQuestion);
        getQuestionBookPage({ ...paramFethQuestion })
          .then(async (res) => {
            if (res && res.data && !res.errors) {
              // Replace link img & media in question content
              let questionReplaceContent = await res.data.map((ques) => {
                let typeQuestion =
                  ques.type === TYPE_GROUP ? "group" : "single";
                ques = setContentMediaEditorShow({ ...ques }, typeQuestion);
                return ques;
              });

              self.questions = await questionReplaceContent;
              /** End fix */

              self.fetchAraeQuestions();
            } else {
              self.questions = [];
            }
            // Set corrected
            // self.initCorrectQuestion()
          })
          .catch()
          .finally(() => self.setLoading(false));
      } else {
        self.setLoading(false);
      }
      this.actionSetBookIdForError(self.ebooksDetail.bookId);
    },

    async getMediaInfoOfPage() {
      let self = this;
      self.setLoading(true);
      let pageActive = self.setPageActive();
      /**
       * Params call media info:
       * bookId - bookPageId=0 - pageNo
       **/
      let paramFethMedia = { bookId: self.ebooksDetail.bookId, pageNo: 0 };
      const requestGetMedia = await pageActive.map((page) => {
        return getMediaInBookPage({
          ...paramFethMedia,
          pageNo: page,
          keyword: "",
        }).then((res) => {
          return { ...res, pageNo: page };
        });
      });

      Promise.all(requestGetMedia)
        .then((res) => {
          let pagesImg = document.getElementsByClassName("page-wrapper");
          self.insertMediaIntoPage(res, pagesImg, pageActive);
        })
        .finally(() => self.setLoading(false));
    },

    viewMoreMedia(data) {
      const self = this;
      let paramFethMedia = {
        bookId: self.ebooksDetail.bookId,
        pageNo: data.pageNo,
        bookPageId: data.bookPageId,
        keyword: "",
      };
      getMediaInBookPage(paramFethMedia)
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            let mediaActive = res.data.filter(
              (media) => media.bookPageLinkId === data.bookPageLinkId
            );
            if (mediaActive.length > 0) {
              let dataMediaPreview = mediaActive[0];
              let indexMediaForFirst = -1;
              if (
                dataMediaPreview.linkPages &&
                dataMediaPreview.linkPages.length > 0
              ) {
                indexMediaForFirst = dataMediaPreview.linkPages.findIndex(
                  (media) => media.pageLinksId === data.pageLinksId
                );
                if (indexMediaForFirst > -1) {
                  dataMediaPreview.linkPages.unshift(
                    dataMediaPreview.linkPages[indexMediaForFirst]
                  );
                  dataMediaPreview.linkPages.splice(indexMediaForFirst + 1, 1);
                }
                dataMediaPreview.linkPages.map(
                  (link) => (link["bookPageId"] = dataMediaPreview.bookPageId)
                );
              }
              return dataMediaPreview;
            }
          }
          return;
        })
        .then((media) => {
          media && self.setDocPreviewSlider(media);
        });
    },

    async fetchAraeQuestions() {
      const self = this;
      if (!self.questions || self.questions.length === 0) {
        return;
      }

      let reqGetArea;
      if (!self.displayTwoPage || self.screenWidth < 992) {
        reqGetArea = await getQuestionAreas(
          self.ebooksDetail.bookId,
          self.page
        );
        reqGetArea &&
          reqGetArea.length &&
          self.insertQuestionIconIntoPage(reqGetArea);
      } else {
        // have 2 page [0, 1]
        reqGetArea = await self.pageCurrent.map((page) => {
          return getQuestionAreas(self.ebooksDetail.bookId, page).then(
            (res) => {
              /**
               * Fix bug 38: ...
               * Modified: anhdd (24/8/2022)
               */
              // console.log("authInfo.email", self.authInfo.email);
              // console.log("ebooksDetail", self.ebooksDetail.limitPracticeX);
              // console.log("page", page);
              if (page <= self.ebooksDetail.limitPracticeY) {
                return getQuestionAreas(self.ebooksDetail.bookId, page).then(
                  (res) => {
                    if (!res || (res && res.length === 0)) {
                      return [];
                    }
                    return res;
                    /*
                     * Add key area for append icon exercise into page img
                     * listQuestionGroupPage key for new function exercise dont show all question of page
                     */
                  }
                );
              } else if (
                this.isContainsEmailUnlimited(self.authInfo.email) ||
                self.authInfo.email === this.emailNxb3
              ) {
                return getQuestionAreas(self.ebooksDetail.bookId, page).then(
                  (res) => {
                    if (!res || (res && res.length === 0)) {
                      return [];
                    }
                    return res;
                    /*
                     * Add key area for append icon exercise into page img
                     * listQuestionGroupPage key for new function exercise dont show all question of page
                     */
                  }
                );
              } else return [];
            }
          );
        });

        Promise.all(reqGetArea).then((res) => {
          res && self.insertQuestionIconIntoPage([...res[0], ...res[1]]);
        });
      }
    },

    insertLessonIconIntoPage(lessons) {
      const self = this;
      if (!lessons || lessons.length === 0) {
        return;
      }
      const iconImg = require("@/assets/images/ebook-lesson.svg");
      // let bookPage = $(`.page-wrapper[page="${self.screenWidth < 992 || !self.displayTwoPage ? self.page : self.pageCurrent[0]}"]`)
      // let boxWrapIcon = `<div id="ss_lesson" class="position-center-y" style="position: absolute; left: 5px; width: 26px;"></div>`
      // bookPage && bookPage.append(boxWrapIcon)

      let htmlAppend = "";
      lessons.map(async (area, index) => {
        if (!area || !area.pageNo) {
          return;
        }

        if (
          self.queryRoute &&
          self.queryRoute.lesson &&
          self.queryRoute.location &&
          parseInt(self.queryRoute.location) === area.lessonPlanLocationId &&
          self.queryRoute.page
        ) {
          // self.getLessonForPage(area.pageNo, area)
          self.handleDirectToLesson(area);
        }

        const countLesson =
          area.listLessonPlanValue.length > 1
            ? `<span class="ss-media__count">${area.listLessonPlanValue.length}</span>`
            : "";
        const imgHtml = `<div
                                    id="ss_lesson_${area.pageNo}_${index}_icon"
                                    class="ss-lesson__icon cursor-pointer img-icon-question"
                                    style="position: absolute; top: ${area.icon.top}%; left: ${area.icon.left}%;"
                                  >
                                  <div class="ss-lesson__icon__wrap position-rel">
                                    <img src="${iconImg}" class="img-links">
                                    ${countLesson}
                                  </div>
                                </div>`;
        htmlAppend = `<div
                              id="ss_lesson_${area.pageNo}_${index}"
                              style="position: absolute; width: ${area.width}%; height: ${area.height}%; top: ${area.top}%; left: ${area.left}%; border: 1px solid transparent;"
                              class="display-flex-end justify-content-end ss-lesson cursor-pointer"
                            >
                              <div class="position-rel full-box display-flex justify-content-center">
                                ${imgHtml}
                              </div>
                            </div>`;
        let bookPage = $(`.page-wrapper[page="${area.pageNo}"]`);
        if (bookPage.length > 0) {
          bookPage.append(htmlAppend);

          // let boxLesson = document.getElementById(`ss_lesson_${area.pageNo}_${index}_icon`)
          let boxLesson = document.getElementById(
            `ss_lesson_${area.pageNo}_${index}`
          );

          if (boxLesson) {
            boxLesson.addEventListener("click", function () {
              self.handleDirectToLesson(area);
              // self.getLessonForPage(area.pageNo, area)
            });
            boxLesson.addEventListener("touchstart", function () {
              self.handleDirectToLesson(area);
              // self.getLessonForPage(area.pageNo, area)
            });
          }
        }
      });
    },

    insertQuestionIconIntoPage(areas) {
      const self = this;
      if (!areas || areas.length === 0) {
        return;
      }
      const iconImg = require("@/assets/images/ebook-exercise.svg");
      const iconImgGray = require("@/assets/images/pencil.png");
      let htmlAppend = "";
      areas.map((area, index) => {
        if (!area || !area.pageNo) {
          return;
        }

        if (
          self.queryRoute &&
          self.queryRoute.question &&
          parseInt(self.queryRoute.question) === area.questionLocationId &&
          self.queryRoute.page &&
          parseInt(self.queryRoute.page) === area.pageNo
        ) {
          self.handleSetQuestionWorking(area);
        }

        const countQuesion =
          area.listQuestionValue.length > 1
            ? `<span class="ss-media__count">${area.listQuestionValue.length}</span>`
            : "";

        let imgHtml = "";
        /**
         * Fix bug 38: ...
         * Modified: anhdd (23/9/2022)
         */
        if (
          area.pageNo <= self.ebooksDetail.limitPracticeX ||
          (self.ebooksDetail.actived &&
            area.pageNo <= self.ebooksDetail.limitPracticeY) ||
          this.isContainsEmailUnlimited(self.authInfo.email) ||
          self.authInfo.email === this.emailNxb3
        ) {
          imgHtml = `<div
                                    id="ss_question_${area.pageNo}_${index}_icon"
                                    class="ss-question__icon cursor-pointer img-icon-question"
                                    style="position: absolute; top: ${area.icon.top}%; left: ${area.icon.left}%;"
                                  >
                                  <div class="ss-question__icon__wrap position-rel">
                                    <img src="${iconImg}" class="img-links">
                                    ${countQuesion}
                                  </div>
                                </div>`;
        } else
          imgHtml = `<div
                                    id="ss_question_${area.pageNo}_${index}_icon"
                                    class="ss-question__icon cursor-pointer img-icon-question"
                                    style="position: absolute; top: ${area.icon.top}%; left: ${area.icon.left}%;"
                                  >
                                  <div class="ss-question__icon__wrap position-rel">
                                    <img src="${iconImgGray}" class="img-links">
                                    ${countQuesion}
                                  </div>
                                </div>`;
        /**
         * End Fix bug 38: ...
         * Modified: anhdd (23/9/2022)
         */
        htmlAppend = `<div
                              id="ss_question_${area.pageNo}_${index}"
                              style="position: absolute; width: ${area.width}%; height: ${area.height}%; top: ${area.top}%; left: ${area.left}%; border: 1px solid transparent;"
                              class="display-flex-end justify-content-end ss-question cursor-pointer"
                            >
                              <div class="position-rel full-box display-flex justify-content-center">
                                ${imgHtml}
                              </div>
                            </div>`;
        let bookPage = $(`.page-wrapper[page="${area.pageNo}"]`);
        if (bookPage.length > 0) {
          bookPage.append(htmlAppend);

          let boxQuestion = document.getElementById(
            `ss_question_${area.pageNo}_${index}`
          );
          boxQuestion.addEventListener("click", function () {
            self.handleSetQuestionWorking(area);
          });
          boxQuestion.addEventListener("touchstart", function () {
            self.handleSetQuestionWorking(area);
          });
        }
      });
    },

    insertMediaIntoPage(data, pageElements, pageActive) {
      let self = this;
      // console.log('Insert: ', data)
      let htmlAppend = "";
      if (data.length > 0) {
        data.map((media) => {
          if (media && media.data && media.data.length > 0 && !media.errors) {
            // console.log('Media data', media)
            // self.listMediaPage = [...self.listMediaPage, ...media.data];
            media.data.map((link, index) => {
              if (link && link.linkPages) {
                if (link.linkPages && link.linkPages.length > 0) {
                  link.linkPages.map((lpa) => {
                    lpa["isShowFree"] = link.isShowFree;
                    lpa["isPublish"] = link.isPublish;
                    lpa["isActived"] = link.isActived;
                    lpa["pageNo"] = media.pageNo;
                    lpa["link"] = link;
                  });
                }
                self.listMediaPage = [...self.listMediaPage, ...link.linkPages];
                let linkActive = link.isShowFree && link.isShowFree !== 0;
                // self.listMediaPage.push(link);
                // let colorPath1 = !linkActive && !self.ebooksDetail.actived ? '#ccc' : link.codeColor ? link.codeColor : '#0f3dba';
                // let colorPathAfter = ['rgba(255,255,255)', '#fff', '#ffffff'].includes(link.codeColor) ? '#0f3dba' : '#fff';

                // let iconForLink = `<span class="icon-play font-size-24"><span class="path1" style="color: ${colorPath1}"></span><span class="path2" style="color: ${colorPathAfter}"></span></span>`;
                /*
                 * Link Lock: number 3
                 * Link free publish: 2
                 * Link free dont publish: 1
                 **/

                // Handle open modal view media
                // if (self.queryRoute && self.queryRoute.shared === window.location.origin && self.queryRoute.book_page_link && link.bookPageLinkId === parseInt(self.queryRoute.book_page_link) ) {
                //   self.handleViewMedia(link, media, linkActive)
                // }
                if (
                  self.queryRoute &&
                  self.queryRoute.media &&
                  parseInt(self.queryRoute.media) === link.bookPageLinkId &&
                  self.queryRoute.page
                ) {
                  // self.handleViewMedia(link, media, linkActive)
                  link && self.acSetMediaBookViewing({ ...link });
                }

                let typeIcon =
                  !linkActive && !self.ebooksDetail.actived
                    ? "-3"
                    : link.isPublish && link.isPublish !== 0
                    ? "-2"
                    : "";
                if (
                  this.authInfo &&
                  (this.isContainsEmailUnlimited(self.authInfo.email) ||
                    this.authInfo.email === this.emailNxb3)
                ) {
                  typeIcon = "-2";
                }
                let countLinkPages = link.linkPages.length;
                let nameIcon =
                  countLinkPages > 1
                    ? "nhom-hoc-lieu"
                    : self.getNameIcomImg(link.linkPages[0].linkUrl);
                let imgIcon = require(`@/assets/images/linktypes/${nameIcon}${typeIcon}.svg`);
                let countTpl =
                  countLinkPages > 1
                    ? `<span class="ss-media__count">${countLinkPages}</span>`
                    : "";
                const stylePositionIcon =
                  link.icon && link.icon.top === 0 && link.icon.left === 0
                    ? "position: absolute;bottom: -10px;top: auto;left: auto;right: auto;"
                    : `position: absolute; top: ${link.icon.top}%; left: ${link.icon.left}%;`;

                let iconForLink = `<span
                                              id="ss_media_${media.pageNo}_${index}_icon"
                                              class="ss-media__icon"
                                              style="${stylePositionIcon}"
                                            >
                                            <div class="ss-question__icon__wrap position-rel">
                                              <img src="${imgIcon}" class="img-links">${countTpl}
                                            </div>
                                          </span>`;

                // let iconForLink =  `<span class="icon-nhom-hoc-lieu${typeIcon} font-size-24"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>`
                // let iconForLink = '<span class="icon-gif-2"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span></span>'

                // let iconForLink =  `<span class="icon-nhom-hoc-lieu font-size-24"><span class="path1" style="color: ${colorPath1}"></span><span class="path2" style="color: ${colorPathAfter}"></span><span class="path3" style="color: ${colorPathAfter}"></span><span class="path4" style="color: ${colorPathAfter}"></span></span>`
                // if(self.checkTypeDocs(link.linkUrl) === typesFile.NAME_DOC_IMG) {
                //     iconForLink = '<i class="icon-image font-size-24"></i>';
                // }

                htmlAppend = `<div id="ss_media_${media.pageNo}_${index}" style="position: absolute; width: ${link.width}%; height: ${link.height}%; top: ${link.top}%; left: ${link.left}%; border: 1px solid transparent;" class="cursor-pointer display-flex-end justify-content-end ss-media ss-media--${link.linkTypeId}"><div  class="position-rel full-box display-flex justify-content-center">${iconForLink}</div></div>`;
                let bookPage = $(`.page-wrapper[page="${media.pageNo}"]`);

                if (bookPage.length > 0) {
                  bookPage.append(htmlAppend);
                  // let boxMedia = document.getElementById(`ss_media_${media.pageNo}_${index}_icon`);
                  let boxMedia = document.getElementById(
                    `ss_media_${media.pageNo}_${index}`
                  );
                  boxMedia.addEventListener("click", function () {
                    // console.log('Çlick media');
                    self.handleViewMedia(link, media, linkActive);
                  });
                  boxMedia.addEventListener("touchstart", function () {
                    // console.log('Çlick media');
                    self.handleViewMedia(link, media, linkActive);
                  });
                }
              }
            });
          }
        });
      }
    },

    async handleDirectToLesson(lesson) {
      const self = this;
      if (
        !lesson ||
        !lesson.lessonPlanLocationId ||
        !lesson.listLessonPlanValue
      ) {
        return;
      }
      let lessonData = [];
      await self.lessons.map((less) => {
        lesson.listLessonPlanValue.includes(less.lessonPlanId) &&
          lessonData.push(less);
      });

      // const lessonData = await self.setLessonDataToStore(lesson)
      // console.log('Lesson data convert: ', lessonData);
      // self.acSetLessonBookViewing({...lessonData})
      const lessonIndexActive =
        self.$route.query && self.$route.query.lesson
          ? self.$route.query.lesson
          : 1;
      self.acSetLessonBookViewing([...lessonData]);

      if (
        !self.$route.query.lesson ||
        !self.$route.query.location ||
        self.$route.query.location != lesson.lessonPlanLocationId
      )
        self.$router.replace({
          query: {
            location: lesson.lessonPlanLocationId,
            lesson: lessonIndexActive,
            page: lesson.pageNo,
          },
        });
    },

    setQuestionsForPage() {
      const self = this;
      /**
       * Params call questions:
       * bookId - bookIndexId - pageIndex - numberOfPage
       **/
      let pageActive = self.setPageActive();
      let numberOfPage = self.displayTwoPage ? 2 : 1;
      let paramFethQuestion = {
        bookId: self.ebooksDetail.bookId,
        bookIndexId: 0,
        pageIndex: pageActive[0],
        numberOfPage,
      };
      // console.log('params search: ', paramFethQuestion);
      return getQuestionBookPage({ ...paramFethQuestion }).then(async (res) => {
        if (res && res.data && !res.errors) {
          // Replace link img & media in question content
          let questionReplaceContent = await res.data.map((ques) => {
            return ques;
          });

          return questionReplaceContent;
        } else {
          return [];
        }
        // Set corrected
        // self.initCorrectQuestion()
      });
    },

    /*
     * Args: question Array ID question
     */
    async handleSetQuestionWorking(area) {
      const self = this;
      /**
       * Fix bug 38: ...
       * Modified: anhdd (23/9/2022)
       */

      if (
        self.authInfo &&
        self.authInfo.email === self.emailPublic &&
        !self.ebooksDetail.actived &&
        area.pageNo > self.ebooksDetail.limitPracticeX
      ) {
        this.onCheckLogin();
      } else if (
        area.pageNo > self.ebooksDetail.limitPracticeX &&
        !self.ebooksDetail.actived &&
        !this.isContainsEmailUnlimited(self.authInfo.email) &&
        self.authInfo.email != this.emailNxb3
      ) {
        // self.acSetDataBookActiveWant({...self.ebooksDetail})
        setTimeout(() => {
          self.acToggleModalActiveBook(true);
        }, 100);
        /**
         * End Fix bug 38: ...
         * Modified: anhdd (23/9/2022)
         */
      } else if (
        area.pageNo > self.ebooksDetail.limitPracticeY &&
        !self.ebooksDetail.actived &&
        !this.isContainsEmailUnlimited(self.authInfo.email) &&
        self.authInfo.email == this.emailNxb3
      ) {
        // self.acSetDataBookActiveWant({...self.ebooksDetail})
        setTimeout(() => {
          self.acToggleModalActiveBook(true);
        }, 100);
        /**
         * End Fix bug 38: ...
         * Modified: anhdd (23/9/2022)
         */
      } else {
        /**
         * Origin Bug 38
         * CommentedBy: anhdd (23/9/2022)
         */
        // Fetch again questions
        self.questions = await self.setQuestionsForPage();
        /*
         * Add key area for append icon exercise into page img
         * listQuestionGroupPage key for new function exercise dont show all question of page
         */
        let result = { listQuestionGroupPage: [] };
        if (!area || area.listQuestionValue.length === 0) {
          return;
        }

        area.listQuestionValue.map((id, index) => {
          let question = self.questions.find((ques) => ques.questionId === id);
          if (!question) {
            return;
          }

          if (index === 0) {
            result = { ...question, listQuestionGroupPage: [question] };
          } else {
            result.listQuestionGroupPage.push(question);
          }
        });
        // console.log('Question working in book: ', result)
        self.acSetEbookQuestionWork({ ...result });
        !self.$route.query.question &&
          self.$router.replace({
            query: { question: area.questionLocationId, page: area.pageNo },
          });
        /**
         * End Origin Bug 38
         * CommentedBy: anhdd (23/9/2022)
         */
      }
    },

    setLessonDataToStore(lesson) {
      if (!lesson) {
        return;
      }
      let result = { ...lesson, lessonPlan: {}, script: {} };
      const idLesson = 1;
      const idScript = 2;
      lesson.listModels &&
        lesson.listModels.map((les) => {
          if (les.bookLessonPlanTypeId === idLesson) {
            // result.lessonPlan = {...les, totalPage: 10}
            result.lessonPlan = les;
          } else if (les.bookLessonPlanTypeId === idScript) {
            result.script = les;
          }
        });
      return result;
    },

    handleViewMedia(link, media, linkActive) {
      // console.log(link, media, linkActive);
      // console.log("View media");
      const self = this;

      if (
        this.isContainsEmailUnlimited(self.authInfo.email) ||
        this.authInfo.email == this.emailNxb3
      ) {
        self.acSetMediaBookViewing({ ...link });
        // Dont redirect repeat
        self.$router.replace({
          query: {
            media: link.bookPageLinkId,
            page: media.pageNo,
            pageRead: this.page,
          },
        });
        return;
      }

      if (
        self.authInfo &&
        self.authInfo.email === self.emailPublic &&
        !self.ebooksDetail.actived &&
        !linkActive
      ) {
        this.onCheckLogin();
      } else if (!linkActive && !self.ebooksDetail.actived) {
        // self.acSetDataBookActiveWant({...self.ebooksDetail})
        setTimeout(() => {
          self.acToggleModalActiveBook(true);
        }, 100);
      } else {
        // console.log("Handle 1");
        self.acSetMediaBookViewing({ ...link });
        // Dont redirect repeat
        self.$router.replace({
          query: {
            media: link.bookPageLinkId,
            page: media.pageNo,
            pageRead: this.page,
          },
        });
      }
    },

    handleOffModal() {
      this.setDocPreviewSlider({});
      this.setToggleModalDocSlider(false);
    },

    handleActiveBookSuccess() {
      // this.$bvModal.hide('modal_active_book');
      this.isEvtActiveSuccess = true;

      let dataDetail = {
        ...this.ebooksDetail,
        limitPage: this.ebooksDetail.totalPage,
        actived: true,
      };
      this.setBookDetail(dataDetail);
    },

    handleSendTimeReadBook() {
      let totalTime = callTimeDiff(this.startTimeReaded);
      let payloadRead = {
        bookId: this.ebooksDetail.bookId,
        timeReading: totalTime.minute,
      };
      setTimeReadBook(payloadRead);
    },

    async handleChangeFullSizeBook(val) {
      this.isFullSizeBook = val;
      this.openBookCats = false;
      // this.setStyleHeightForMobile()
      await this.setHeightBookViewer();
      this.resetPageWhenOfBoxsTransition();
    },

    resetAreaQuestionAndMedia() {
      $(".ss-media").remove();
      $(".ss-question").remove();
      $(".ss-lesson").remove();
    },

    fetchDataInPage() {
      const self = this;
      // Promise.allSettled([self.getMediaInfoOfPage(), self.getQuestionsForPage(), self.fetchAreaLessonOnPage()])
      Promise.allSettled([
        self.getMediaInfoOfPage(),
        self.getQuestionsForPage(),
        self.getLessonForPage(),
      ]);
    },

    changeViewBookNew(value) {
      const self = this;
      self.changeViewBook(value);
      // Reset zoom
    },
  },
};
</script>
<style lang="css" scoped>
.book-viewer__switch.only-pc {
  width: 60px;
}
.switch-viewpage {
  position: relative;
  cursor: pointer;
}
.switch-viewpage input {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}
.switch-viewpage i {
  color: #316cc5;
  width: 30px;
  height: 30px;
  display: block;
  font-size: xx-large;
}
.switch-viewpage label {
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 20px;
  padding-right: 10px;
  margin: 0;
}

/* The Modal (background) */
.modalviewer {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modalviewer .modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 50%; /* Could be more or less, depending on screen size */
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  text-align: right;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>
<style lang="scss" scoped>
.icon-help {
  position: absolute;
  right: 25px;
}
.total-questions {
  position: absolute;
  width: 18px;
  height: 18px;
  background: #e3342f;
  border-radius: 50%;
  top: 2px;
  right: 12px;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 17px;
}
.total-a {
  position: relative;
}
.show-document {
  .inner-content {
    z-index: 1000;
  }

  .modal-wrap {
    background-color: rgba($primary_text_color, 0.8);
  }
}

.modal-confirm {
  padding: 20px 15px;
  p {
    margin-bottom: 15px;
  }
  &__action {
    > * {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}

.questions-child {
  padding: 20px 0 20px 40px;
}

.icon-sidebar {
  &__exercise {
    &.limit {
      opacity: 0.7;

      i {
        color: #ccc;
      }
      .total-questions {
        background: #ccc;
      }
    }
  }
}
.read-ebook2 {
  display: flex;
}
.book-viewer .chevron-next {
  z-index: 100;
}
.list-tab-menu {
}
.list-hoc-lieu,
.tab-luyen-tap {
  overflow: auto;
  margin-top: 10px;
  height: calc(100vh - 350px);
}
.noti-luyen-tap {
  text-align: center;
  font-family: sandisplaypro-semi;
}
.list-extension {
  width: 80%;
  display: flex;
  margin: auto;
  margin-top: 10px;
  text-align: center;
}
.list-extension div {
  width: 32%;
  margin: 2px;
}
.item-extension {
  color: #fff;
  border: none;
  border-radius: 10px;
  width: 100%;
  margin: 5px;
  font-family: sandisplaypro-semi;
}
.list-tab-menu-title {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #dbdbdb;
}
.count-question-title {
  padding: 5px;
  background: #ffffff;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border-top: 3px solid blue;
  color: #4579ca;
  font-family: sandisplaypro-semi;
}
.count-question-content {
  text-align: center;
  margin-top: 5px;
  color: #576c76;
  font-family: sandisplaypro-semi;
}
.statitic-question {
  position: absolute;
  bottom: 0;
  left: 25%;
}
@media only screen and (max-width: 1500px) {
  /* styles for browsers larger than 960px; */
  .statitic-question {
    position: absolute;
    bottom: 0;
    left: 18%;
  }
}
@media only screen and (max-width: 1366px) {
  /* styles for browsers larger than 960px; */
  .statitic-question {
    position: absolute;
    bottom: 0;
    left: 10%;
  }
}
.tab-link .item-link {
  display: flex;
  padding: 5px;
}
.inner-img {
  width: 100px;
}
.tab-search {
  width: 60px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 20px;
  padding-right: 10px;
  cursor: pointer;
}
.content-tab-menu {
  width: 100%;
  background-color: #f3f6fb;
  position: relative;
}
.item-link-right {
  margin-left: 10px;
  color: #607781;
  width: 70%;
}
.search-course {
  width: 80%;
  background: white;
  height: 30px;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 15px;
  position: relative;
}
.input-search-course {
  width: 85%;
  border: none;
  outline: none;
  margin-top: 3px;
  margin-left: 5px;
  font-family: sandisplaypro-semi;
}
.search-course img {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
.item-link-right div {
  font-family: sandisplaypro-semi;
  height: calc(100% - 73px);
  color: #8ba4af;
  font-size: 14px;
}
.item-link-right h5 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #667982;
  font-family: sandisplaypro-semi;
  font-size: 18px;
  font-weight: 600;
}
.tab-link {
  height: calc(100vh - 190px);
  overflow-x: auto;
}
.btn-read-book-link {
  text-decoration: none;
  background-color: #e1efff;
  color: #40505e;
  border-radius: 20px;
  padding: 4px 20px;
  color: #124abe;
  border: none;
}
.tab-menu-title {
  width: 32%;
  text-align: center;
  font-family: sandisplaypro-semi;
  padding: 10px;
  cursor: pointer;
  color: #829da8;
}
.active-tab-menu-title {
  border-bottom: 2px solid #0058b8;
  color: #2b74c4 !important;
}
.active-tab-menu {
  background: #f3f6fb;
}
.suggest {
  margin-top: 50px;
  display: flex;
}

.icon-hoc-lieu {
  position: absolute;
  width: 20px;
  left: 50%;
  top: 50%;
}

.item-hoc-lieu {
  margin-top: 5px;
}
.list-course {
  display: flex;
  justify-content: center;
  background: white;
  width: 60%;
  border-radius: 10px;
}
.item-statitic {
  text-align: center;
  position: relative;
}
.item-statitic img {
  width: 70%;
}
.count-item-statitic {
  position: absolute;
  bottom: 0;
  min-width: 20px;
  right: 4px;
  background: #def0fe;
  color: #8db2e2;
  border-radius: 10px;
  padding: 3px;
  font-size: 50%;
  font-family: sandisplaypro-semi;
}

.title-course {
  text-align: center;
  font-size: 18px;
  color: #4081c9;
  font-family: sandisplaypro-semi;
}
.item-statitic img {
}
.book-viewer {
  &__body {
    width: 75%;
  }
  &__question {
    padding: 0 25px;
  }

  &__nav {
    button {
      width: 30px;
    }
  }
}

@media screen and (min-width: 1200px) {
  .book-viewer__exercise__btns {
    a {
      min-width: 130px;
    }
  }
}
@media screen and (max-width: 1024px) {
  .responsive-next {
    margin-right: 30px;
  }
}
</style>

<style lang="css">
.book-viewer__body .img-links {
  min-width: 22px;
  height: 22px;
}
</style>